import Dependency from './Dependency';
import DataStore from './../stores/DataStore';

/**
 * @class
 * Klasse, die dafür verantwortlich ist, die Attributabhändigkeiten sowiie die dazugehörigen auswirkuzngen
 * zu organisieren.
 * Dazu wird zunächst für jede Abhängigkeit einzeln eine Dependency angelegt.
 */
class DependencyHandler {
  /**
   *
   * @constructor
   * @param {object} [dependencyOptions]
   * @param {Dependency[]} [dependencyOptions.dependencies=[]]
   *
   */
  constructor(params) {
    const { dependencies = [] } = params;
    this.dependenciesOptions = dependencies;
    this.dependencies = [];
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.buildDependencies();
    this.DataStore = DataStore; 
    this.DataStore.setHandler({dependencyHandler:this});
  }

  /**
   * @function DependencyHandler.buildDependencies Erstellt alle Attrbutabhängigkeiten bgemäß der Configuration
   */
  buildDependencies() {
    this.dependenciesOptions.forEach(dConf => {
      this.dependencies.push(
        new Dependency(dConf),
      );
    });
  }

  /**
   * @function DependencyHandler.refresh Refreshed alle Attributabhngigkeit (z.B. bei Änderungen)
   */
  refresh() {
    this.dependencies.forEach(dep => {
      dep.refresh();
    });
  }
}
export default DependencyHandler;
